import React from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";

export default function QueryCreatedModal({
  show,
  onClose,
  onOpenMyQueries,
  header,
  body,
  className,
  classes,
  showOpenMyQueries
}) {

  const handleClose = () => {
    if (showOpenMyQueries) {
      onClose?.();
    } else {
      // When Open My Queries is btn is hidden, closing should act like "Open My Queries"
      onOpenMyQueries?.();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      className={className ?? classes?.["query-created-modal"]}
    >
      <Modal.Header>
        <Modal.Title>{header}</Modal.Title>

        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={onClose}
        >
          <span aria-hidden="true">
            <FontAwesomeIcon icon={faXmark} />
          </span>
        </button>
      </Modal.Header>

      <Modal.Body>{body}</Modal.Body>

      <Modal.Footer>
        {showOpenMyQueries && (
          <button
            type="button"
            className={`btn btn-secondary ${classes?.["open-myqueries-btn"] ??
              ""}`}
            onClick={onOpenMyQueries}
          >
            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />{" "}
            <span>Open My Queries</span>
          </button>
        )}
        <button
          type="button"
          className={`btn btn-primary ${classes?.["okay-btn"] ?? ""}`}
          onClick={handleClose}
        >
          OK
        </button>
      </Modal.Footer>
    </Modal>
  );
}